import React from 'react';
import { ShieldCheckIcon, ClockIcon, ReceiptTextIcon, LanguagesIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [ShieldCheckIcon, ClockIcon, ReceiptTextIcon, LanguagesIcon];
export function TrustBar() {
  const {
    t
  } = useLanguage();
  return <section aria-label={t.trust.aria} className="w-full bg-forest-light" data-id="element-206" data-mp="1370w6fe40r9j">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-6 px-5 py-8 sm:py-9 lg:grid-cols-4 lg:px-8" data-id="element-207" data-mp="1qxo4v2vunkx5">
        {t.trust.items.map((label, index) => {
        const Icon = icons[index];
        return <div key={label} className="flex items-center gap-3" data-id="element-208" data-mp="1h007s6aru1bt" data-mpi={index}>
              <Icon className="h-6 w-6 shrink-0 text-rust-light" aria-hidden="true" data-id="element-209" data-mp="1lybguet8s7sz" />
              <span className="font-display text-sm font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-210" data-mp="1m04re56z7c69">
                {label}
              </span>
            </div>;
      })}
      </div>
    </section>;
}